import {curry} from 'ramda';

import {
    commitLog,
    imagePackageEvent,
    mediaEvent,
    reset,
    resetCounters,
    videoPackageEvent,
} from './util';

const handlers = {
    image: imagePackageEvent(false),
    video: videoPackageEvent(false),
};

const actions = {
    image: {
        title: 'imageTitleChanged',
        caption: 'imageCaptionChanged',
        alt: 'imageAltTextChanged',
    },
    video: {
        title: 'videoTitleChanged',
        caption: 'videoCaptionChanged',
        alt: 'videoAltTextChanged',
    },
};

export const changeAttribute = curry(
    (type, name, opts) => handlers[type] && actions[type][name] && handlers[type](actions[type][name], opts),
);

export const cancelImageChanges = label => {
    imagePackageEvent(true, 'imageEditsCanceled', {label});
    reset();
};

export const changeImageAttribute = changeAttribute('image');

export const changeVideoAttribute = changeAttribute('video');

export const saveImageChanges = label => {
    resetCounters();
    imagePackageEvent(false, 'imageEditsSaved', {label});
    commitLog();
};

export const saveVideoChanges = label => {
    videoPackageEvent(false, 'videoChangesSaved', {label});
    commitLog();
};

export const cropImage = label => imagePackageEvent(false, 'imageCropped', {label});
export const previewImage = label => imagePackageEvent(false, 'renditionPreviewUsed', {label});
export const makesClip = label => videoPackageEvent(true, 'clipCreated', {label});
export const makesInstantClip = label => videoPackageEvent(true, 'instantClipCreated', {label});
export const mp4Download = label => videoPackageEvent(true, 'mp4Downloaded', {label});

export const uploadMediaInitiated = () => mediaEvent(true, 'uploadMediaInitiated', {});
export const uploadMediaCompleted = (type, label) => mediaEvent(true, `${type}Uploaded`, {label});
export const editMediaInitiated = (type, label) => mediaEvent(true, `${type}EditInitiated`, {label});
